import React from  "react"

export default ({keyWord})=> <span className="chip">
<h4 style={{fontWeight: "normal", padding: "0", margin: "0"}}>{keyWord}</h4></span>